/* eslint-disable */

import { Avatar, Button, Form, Input, Modal, Radio, Result, Select, Spin, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { _account_number_verification, _bank_verification, _calc_commission, _get_all_banks, _get_beneficiaries, _get_profile, _get_user_account_history, _payout, _payout_internal, _rate_setting_by_id, _verify_2fa, _verify_pin, _wallet_verification } from '../../common/axios_services';

const schema = yup.object().shape({
  firstname: yup.string().required('First name is required'),
  lastname: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  telephone: yup
    .string()
    .matches(/^\d+$/, 'Only numbers are allowed')
    .min(10, 'Telephone must be at least 10 digits')
    .required('Telephone is required'),
});


const DeliveryPersonModal = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [deliveryPerson, setDeliveryPerson] = useState(false);
  const params = new URLSearchParams(window?.location?.search);

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title ? title : "",
      description: message ? message : "",
      placement: "bottom-right"
    });
  };
  const jwt = localStorage.konnect_token;

  if (!jwt) {
    openNotificationWithIcon('error', "Something went wrong", 'Unauthorized')
    return navigate('/signin')
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log('Form Data:', data);
  };


  return (
    <>
      <button onClick={() => { setDeliveryPerson(!deliveryPerson); }} className="bg_side_green" style={{ width: "fit-content " }}>Delivery Person</button>
      <Modal centered={true} title="" open={deliveryPerson} footer={null} className="pb-5 pt-5">
        <div style={{ height: "400px", overflowY: "auto" }}>
          <h2 style={{ fontSize: "2.5rem" }} className='mb-3'>Biker Account ID</h2>
          <Form layout="vertical" onFinish={handleSubmit(onSubmit)} style={{ maxWidth: 500, margin: 'auto' }}>
            <Form.Item label="First Name" validateStatus={errors.firstname ? 'error' : ''} help={errors.firstname?.message}>
              <Controller
                name="firstname"
                control={control}
                render={({ field }) => <Input {...field} placeholder="Enter first name" />}
              />
            </Form.Item>

            <Form.Item label="Last Name" validateStatus={errors.lastname ? 'error' : ''} help={errors.lastname?.message}>
              <Controller
                name="lastname"
                control={control}
                render={({ field }) => <Input {...field} placeholder="Enter last name" />}
              />
            </Form.Item>

            <Form.Item label="Email" validateStatus={errors.email ? 'error' : ''} help={errors.email?.message}>
              <Controller
                name="email"
                control={control}
                render={({ field }) => <Input {...field} placeholder="Enter email" />}
              />
            </Form.Item>

            <Form.Item label="Telephone" validateStatus={errors.telephone ? 'error' : ''} help={errors.telephone?.message}>
              <Controller
                name="telephone"
                control={control}
                render={({ field }) => <Input {...field} placeholder="Enter telephone number" />}
              />
            </Form.Item>

            <Form.Item>
              <div className='flex justify-between mt-3 pt-3'>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
                <Button onClick={() => setDeliveryPerson(false)}>Cancel</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  )
}
export default DeliveryPersonModal;
